module.exports = require("core-js/library/fn/array/includes");


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/core-js/array/includes.js
// module id = 229
// module chunks = 1